import { AfterViewInit, Component, computed, inject, input, model, output, ViewChild } from '@angular/core';
import { Router } from '@angular/router';
import { AuthService } from 'src/app/services';
import { MatButtonModule } from '@angular/material/button';
import { NgIf } from '@angular/common';
import { MatIconModule } from '@angular/material/icon';
import { Status } from 'src/app/_models/status.model';
import { MatPaginator, MatPaginatorModule, PageEvent } from '@angular/material/paginator';

@Component({
  selector: 'kbm-books-header',
  standalone: true,
  imports: [
    MatButtonModule,
    MatIconModule,
    MatPaginatorModule,
  ],
  templateUrl: './books-header.component.html',
  styleUrls: ['./books-header.component.scss']
})
export class BooksHeaderComponent implements AfterViewInit {

  router = inject(Router);
  authService = inject(AuthService);

  setCount = input.required<number>();
  totalCount = input.required();
  pageEvent = output<PageEvent>();
  status = model.required<Status>();
  isLoggedIn = computed(() => this.authService.isLoggedIn());

  @ViewChild(MatPaginator)
  paginator: MatPaginator | undefined;

  PAGE_SIZE_OPTIONS = [5, 10, 20, 50, 100];

  constructor() { }

  ngAfterViewInit(): void {
    if (this.paginator) {
      this.paginator.length = (this.setCount ? Number(this.setCount) : 0);
      this.paginator.pageSize = (this.status().pageSize ? Number(this.status().pageSize) : 10);
      this.paginator.pageIndex = (this.status().pageIndex ? Number(this.status().pageIndex) : 0);
      this.paginator.pageSizeOptions = this.PAGE_SIZE_OPTIONS;

      this.paginator.page
        .subscribe(() => {
          this.status.update((s) => {
            s.pageIndex = this.paginator?.pageIndex || 0;
            s.pageSize = this.paginator?.pageSize || 11;
            if (this.paginator) {
              s.startingIdx = this.paginator?.pageIndex * this.paginator?.pageSize ;
              s.endingIdx = ((this.paginator?.pageIndex + 1) * this.paginator?.pageSize > this.setCount() ? this.setCount() : (this.paginator?.pageIndex + 1) * this.paginator?.pageSize);
            } else {
              s.startingIdx = 0;
              s.endingIdx = 8;
            }
            return s;
          });
        });
    }
  }

  onNewBook(): void {
    sessionStorage.setItem('currentBook', 'AddNew');
    this.router.navigate([
      '/books',
      'AddNew',
      {}
    ]);
  }


  onToggleFilterSort() {
    this.status.update((s) => {
      s.isFilterSortOpen = !s.isFilterSortOpen;
      return s;
    });

  }

  onToggleLayout() {
    this.status.update((s) => {
      s.isGridLayout = !s.isGridLayout;
      return s;
    });
  }


  onPageChange(event: PageEvent) {
    this.pageEvent.emit(event);
  }

}
